import {
	FETCH_PATIENT_ROIS,
	FETCH_PATIENT_ROIS_SUCCESS,
	FETCH_PATIENT_ROIS_ERROR,
	REVOKE_PATIENT_ROI,
	REVOKE_PATIENT_ROI_SUCCESS,
	REVOKE_PATIENT_ROI_ERROR,
	RENEW_PATIENT_ROI,
	RENEW_PATIENT_ROI_SUCCESS,
	RENEW_PATIENT_ROI_ERROR,
} from './constants';

export const fetchPatientRois = () => ({
	type: FETCH_PATIENT_ROIS,
});

export const fetchPatientRoisSuccess = (data) => ({
	type: FETCH_PATIENT_ROIS_SUCCESS,
	data,
});

export const fetchPatientRoisError = (err) => ({
	type: FETCH_PATIENT_ROIS_ERROR,
	err,
});

export const revokePatientRoi = (roiId) => ({
	type: REVOKE_PATIENT_ROI,
	roiId,
});

export const revokePatientRoiSuccess = (data) => ({
	type: REVOKE_PATIENT_ROI_SUCCESS,
	data,
});

export const revokePatientRoiError = (err) => ({
	type: REVOKE_PATIENT_ROI_ERROR,
	err,
});

export const renewPatientRoi = (roiId) => ({
	type: RENEW_PATIENT_ROI,
	roiId,
});

export const renewPatientRoiSuccess = (data) => ({
	type: RENEW_PATIENT_ROI_SUCCESS,
	data,
});

export const renewPatientRoiError = (err) => ({
	type: RENEW_PATIENT_ROI_ERROR,
	err,
});
